/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useState } from 'react';
import { TFunction } from 'i18next';
import { Box, Group, Radio, Stack } from '@mantine/core';

import { CreditOptionsResponse } from 'types';
import { DECIMAL_PROPS, InputLabel, MonthPicker, NumberInput, SectionLabel, Select, Text } from 'components';
import { AppUtils } from 'utils';
import { AppConstants } from '../../../../../../constants';

const { CREDIT_REQUEST_FORM_PADDING } = AppConstants;

interface CreditRequestIncomeItemProps {
  disabled?: boolean;
  form: any;
  options: CreditOptionsResponse;
  t: TFunction;
  userIncomeForm: any;
  index: number;
  tempIncomeObject: object;
  partner: boolean
}

const CreditRequestIncomeItem = ({
  disabled,
  form,
  options,
  index,
  t,
  userIncomeForm,
  tempIncomeObject,
  partner
}: CreditRequestIncomeItemProps) => {

  const [additionalIncome, setAdditionalIncome] = useState<boolean>(userIncomeForm.values[index + 1]);

  const changeAdditionalIncome = useCallback((val: boolean) => {
    setAdditionalIncome(val);
    if (val) {
      AppUtils.addNewObject(userIncomeForm, { ...tempIncomeObject, creditRequestId: form.values.id, partner: partner });
    } else {
      AppUtils.removeObject(userIncomeForm, index + 1, { ...tempIncomeObject, creditRequestId: form.values.id })
    }
  }, []);

  return (
    <Box key={`income-${index}`} mt={'md'}>
      <SectionLabel label={t(`credit.income.${partner ? 'partner.' : ''}label`)} variant={'green'} mb={16} />
      <Stack pb={CREDIT_REQUEST_FORM_PADDING}>
        <Select
          label={t('input.incomeType.label')}
          data={options['incomeType']
            .filter(el => form.values['maritalStatus'] !== 'MARRIED' || el !== 'WIDOWS_PENSION')
            .map(el => (
              { value: el, label: t(`input.incomeType.options.${el}`) }
            ))
          }
          key={userIncomeForm.key(`${index}.incomeType`)}
          {...userIncomeForm.getInputProps(`${index}.incomeType`)}
          clearable={true}
          disabled={disabled}
        />
        <NumberInput
          label={t('input.incomeAmount.label')}
          key={userIncomeForm.key(`${index}.amount`)}
          {...userIncomeForm.getInputProps(`${index}.amount`)}
          min={0}
          rightSection={<Text size={'sm'} >{t('currency.switzerland')}</Text>}
          rightSectionWidth={40}
          disabled={disabled}
          {...DECIMAL_PROPS}
        />
        {userIncomeForm.values[index].incomeType === 'RENT' ?
          <MonthPicker
            label={t('input.rent.startDate')}
            key={userIncomeForm.key(`${index}.startDate`)}
            {...userIncomeForm.getInputProps(`${index}.startDate`)}
            disabled={disabled}
            maxDate={new Date()}
          />
        : undefined}
        {!disabled ?
          <Box mb={6}>
            <InputLabel label={t(`action.addIncome${partner ? 'Partner' : ''}`)} />
            <Group>
              <Radio color={'#75AD53'} checked={additionalIncome} onChange={() => changeAdditionalIncome(true)} label={t('input.radio.true')} disabled={disabled} />
              <Radio color={'#75AD53'} checked={!additionalIncome} onChange={() => changeAdditionalIncome(false)} label={t('input.radio.false')} disabled={disabled} />
            </Group>
          </Box>
        : undefined}
      </Stack>
    </Box>
  )
}

export default CreditRequestIncomeItem;